import { FunnelBookingAuthorizationForm, FunnelBookingAuthorizationListConfiguration, FunnelBookingAuthorizationListCriteria, FunnelBookingAuthorizationLocalization } from "../objects/funnelBookingAuthorization";
import { Column } from "../objects/column";

export const FUNNEL_BOOKING_AUTHORIZATION_MODULE = 'CIRCUIT_FUNNEL_BOOKING_AUTHORIZATION';

export const BOOKING_AUTHORIZATION_DEFAULT_COLUMNS: Column[] = [
    { label: 'name', field_name: 'NAME', checked: true, order_by: 'name', fixed_width: false, last_updated: false, width: null },
    { label: 'rule-type', field_name: 'RULE_TYPE', checked: true, order_by: '', fixed_width: false, last_updated: false, width: null },
    { label: 'destination', field_name: 'DESTINATION', checked: true, order_by: '', fixed_width: false, last_updated: false, width: null },
    { label: 'network', field_name: 'NETWORK', checked: true, order_by: '', fixed_width: false, last_updated: false, width: null },
    { label: 'modified-date', field_name: 'MODIFIED_DATE', checked: true, order_by: 'modified_date', fixed_width: true, last_updated: false, width: null },
    { label: 'modified-by', field_name: 'MODIFIED_BY', checked: false, order_by: 'last_author__username', fixed_width: true, last_updated: false, width: null },
    { label: 'created-date', field_name: 'CREATED_DATE', checked: false, order_by: 'created_date', fixed_width: true, last_updated: false, width: null },
    { label: 'created-by', field_name: 'CREATED_BY', checked: false, order_by: 'creator__username', fixed_width: true, last_updated: false, width: null },
];

export const EMPTY_FUNNEL_BOOKING_AUTHORIZATION_LIST_CONFIGURATION: FunnelBookingAuthorizationListConfiguration = {
    columns: BOOKING_AUTHORIZATION_DEFAULT_COLUMNS,
    preferences: [],
};

export const EMPTY_FUNNEL_BOOKING_AUTHORIZATION_LIST_CRITERIA: FunnelBookingAuthorizationListCriteria = {
    limit: 25,
    page: 0,
    search: '',
    order: 'asc',
    order_by: '',
    cms_id: null,
    funnel_id: null,
};

export const EMPTY_FUNNEL_BOOKING_AUTHORIZATION_LOCALIZATION: FunnelBookingAuthorizationLocalization = {
    name: '',
    locale: 0,
};

export const EMPTY_FUNNEL_BOOKING_AUTHORIZATION_FORM: FunnelBookingAuthorizationForm = {
    name: null,
    name_localized: {},
    localization: [],
    rule_is_to_disallow_booking: false,
    destinations: [],
    networks: [],
    agencies: [],
    mini_networks: [],
    sub_networks: [],
    markets: [],
};
